import { RootState } from '@client/types'

export const getBookmarks = (state: RootState) => state.bookmarks.documents
